export default __webpack_public_path__ + "static/media/tuberose.5c2525da.png";